var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgReplay = function SvgReplay(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.16536 8.73298V5.26698L9.03803 6.99965L7.16536 8.73298ZM7.7247 3.96832C7.3927 3.66032 6.90803 3.58032 6.4907 3.76365C6.08403 3.94099 5.83203 4.32032 5.83203 4.75299V9.24699C5.83203 9.67965 6.08403 10.059 6.4907 10.2363C6.63936 10.3017 6.79736 10.333 6.9527 10.333C7.2347 10.333 7.51136 10.2297 7.72403 10.0323L10.152 7.78565C10.3727 7.58165 10.4987 7.29565 10.4987 6.99965C10.4987 6.70432 10.3727 6.41765 10.152 6.21432L7.7247 3.96832ZM7.4987 12.3333C4.55803 12.3333 2.16536 9.94059 2.16536 6.99992C2.16536 4.05925 4.55803 1.66659 7.4987 1.66659C10.4394 1.66659 12.832 4.05925 12.832 6.99992C12.832 9.94059 10.4394 12.3333 7.4987 12.3333ZM7.4987 0.333252C3.8227 0.333252 0.832031 3.32392 0.832031 6.99992C0.832031 10.6759 3.8227 13.6666 7.4987 13.6666C11.1747 13.6666 14.1654 10.6759 14.1654 6.99992C14.1654 3.32392 11.1747 0.333252 7.4987 0.333252Z",
    fill: "#728188"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReplay, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/replay.6c917fd1.svg";
export { ForwardRef as ReactComponent };